import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminHeader } from '../admin-header/admin-header';
import { AdminSidebar } from '../admin-sidebar/admin-sidebar';

@Component({
  selector: 'app-staff-log',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminHeader, AdminSidebar],
  templateUrl: './staff-logs.html',
  styleUrls: ['./staff-logs.css']
})
export class StaffLogsComponent implements OnInit {
  logs: any[] = [];
  searchTerm = '';
  filteredLogs: any[] = [];

  constructor(private http: HttpClient) {}

  ngOnInit() {
    this.fetchLogs();
  }

  fetchLogs() {
    this.http.get<any[]>('http://localhost:5002/api/staff-logs').subscribe(data => {
      this.logs = data;
      this.filteredLogs = data;
    });
  }

  search() {
    const term = this.searchTerm.toLowerCase();
    this.filteredLogs = this.logs.filter(log =>
      log.staff_name.toLowerCase().includes(term) ||
      log.role.toLowerCase().includes(term) ||
      log.action.toLowerCase().includes(term)
    );
  }
}
